import type { Component } from 'vue';
import { h, reactive, ref } from 'vue';

export function createState(id: number) {
  const state = reactive({
    id: id,

    component: null as Component | null,

    isOpen: ref(false),

    props: ref<Record<string, unknown>>(Object.create(null)),

    onBeforeCloseClb: ref<(() => Promise<void> | void) | undefined>(undefined),

    onClosedClb: ref<(() => Promise<void> | void) | undefined>(undefined),

    // needed because close is async
    closing: false,

    setIsOpen: async (value: boolean) => {
      if (state.closing) {
        return;
      }

      if (value) {
        state.isOpen = true;
      } else {
        state.closing = true;
        await state.close();
        state.closing = false;
      }
    },

    open: (component: Component, props: Record<string, unknown>) => {
      state.component = h(component, props);

      // Delay is fixing css animation
      setTimeout(() => {
        state.isOpen = true;
      });
    },

    close: async () => {
      try {
        if (state.onBeforeCloseClb) {
          await state.onBeforeCloseClb();
        }

        state.isOpen = false;

        if (state.onClosedClb) {
          state.onClosedClb();
          state.onClosedClb = undefined;
        }

        // Delay is fixing css animation
        setTimeout(() => {
          state.component = null;
          state.props = Object.create(null);
        }, 300);
      } catch (e) {
        if (e instanceof Error) {
          throw e;
        }
      }
    },
  });

  return state;
}
